import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useToast } from "@chakra-ui/react";

const NotificationMessage = (props) => {
  const dispatch = useDispatch();
  const toast = useToast();
  useEffect(() => {
    /* toast({
      title: props.title,
      description: props.description,
      status: props.status,
      duration: 2000,
      isClosable: true,
      position: "top",
      containerStyle: {
        direction: "ltr",
        whiteSpace: "pre-line",
      },
    }); */
    toast({
      title: (
        <div style={{ direction: "rtl", textAlign: "right" }}>
          {props.title}
        </div>
      ),
      description: (
        <div
          style={{
            direction: "rtl",
            textAlign: "right",
            whiteSpace: "pre-line",
          }}
        >
          {props.description}
        </div>
      ),
      status: props.status,
      duration: 2000,
      isClosable: true,
      position: "top",
      containerStyle: {
        direction: "ltr", // برای اینکه آیکن سمت چپ بماند
      },
    });

    if (props.cleanerAction) {
      if (props?.id) {
        props.cleanerAction(props.id);
      } else {
        props.cleanerAction();
      }
    }
  }, [toast, props, dispatch]);
  return <></>;
};

export default NotificationMessage;
